import gql from 'graphql-tag'

export const GET_ALL_OEM = gql`
query {
 OEMs{
      id
      name
 }
}
`

export const GET_ALL_PRODUCTLINES = gql`
query {
  ProductLines{
        id
      name
      description
      oemCode
      code
      oemId
      createdOn
      updatedOn
  }
}
`
export const GET_PRODUCT_LINES_BY_OEM = gql`
query ProductLines($oemId:uuid!){
 ProductLines(where:{oemId:{_eq:$oemId}}){
      id
      name
      description
      oemCode
      code
      oemId
      createdOn
      updatedOn
 }
}
`
export const GET_PRODUCTS_BY_PRODUCTLINE = gql`
query Product($productLineId:uuid!){
 Product(where:{productLineId:{_eq:$productLineId}}){
      id
      name
      ProductLine {name}
      description
      sku
      unit
      oemCode
      productLineCode
      productLineId
      oemId
      createdOn
      updatedOn
 }
}
`
export const GET_COUNTS = gql`
query ProductRaw($oemId:uuid!,$ownedBy:uuid!){
  ProductLines(where: {oemId: {_eq: $oemId}}) {
    id
    Products(where: {oemId: {_eq: $oemId}}) {
      id
      ProductInventories(where: {Product: {oemId: {_eq: $oemId}},_and:{ownedBy:{_eq:$ownedBy}}}) {
        id
      }
    }
  }
}
`

export const GET_TRANSFER_SERIAL_SEARCH = gql`
query ProductInventory ($serials:[String!],$ownedBy:uuid!){
  ProductInventory(where: {serial: {_in: $serials}, _and: {ownedBy: {_eq: $ownedBy}}}) {
  serial
  }
}
`
//export const GET_INVENTORY_COUNT=gql`
//query ProductInventory ($productId:uuid!,$ownedBy:uuid!){
//  ProductInventory(where: {productId: {_eq: $productId}, _and: {ownedBy: {_eq: $ownedBy}}}) {
//  id
//  }
//}
//`
export const GET_INVENTORY_COUNT=gql`
query BatchTable ($productId:uuid!,$ownedBy:uuid!){
  BatchTable(where: {productId: {_eq: $productId}, _and: {ownedBy: {_eq: $ownedBy}}}) {
  id
  }
}
`
export const GET_INVENTORY_BY_SERIAL=gql`
query ProductInventorySerial ($productId:uuid!, $serialFilter:String!,$ownedBy:uuid!){
  ProductInventorySerial:ProductInventory(where:{_and:[{productId:{_eq:$productId}}, {serial: {_ilike: $serialFilter}},  {ownedBy: {_eq: $ownedBy}}]}) {
  id
  serial
  }
}
`
export const GET_INVENTORY_BY_BATCH=gql`
query BatchTable ( $batchFilter:String!,$status:String!,$ownedBy:uuid!){
  BatchTable(where: {_and:[{batch: {_ilike: $batchFilter}}, {status: {_eq: $status}}, {ownedBy: {_eq: $ownedBy}}]}, order_by: {batch: asc}) {
  id
  batch
  productId
  Product{name
  ProductLine{name}}
  }
}
`
export const GET_FORTINET_INVENTORY_BY_BATCH=gql`
query BatchTable($batchFilter: String!, $status: String!, $oemCode: String!, $ownedBy: uuid!) {
  BatchTable(where: {_and: [{batch: {_ilike: $batchFilter}}, {status: {_eq: $status}}, {ownedBy: {_eq: $ownedBy}}], Product: {oemCode: {_eq: $oemCode}}}, order_by: {batch: asc}) {
    id
    batch
    productId
    Product {
      name
      ProductLine {
        name
      }
    }
  }
}
`

export const CHECK_ENTERED_BATCHES = gql`
query BatchTable($batches:[String!], $ownedBy:uuid!){
BatchTable(where: {_and:[{batch:{_in:$batches}}, {status: {_eq: "InStock"}}, {ownedBy: {_eq: $ownedBy}}]}) {
    id
    batch
    productId
}}
`
export const GET_ALL_BATCHES = gql`
query {
BatchTable{
batch}
}`

export const GET_PRODUCTS_FROM_BATCH = gql`
query BatchTable($batches:[String!]){
BatchTable(where:{batch:{_in:$batches}}){
    id
    batch
    productId
}}
`
export const GET_PRODUCT_INVENTORY_BY_BATCHID = gql`
query ProductInventory ($batchId:uuid!,$ownedBy:uuid!, $status:String!){
  ProductInventory(where: {_and:[{batchId: {_eq: $batchId}}, {ownedBy: {_eq: $ownedBy}}, {status: {_eq: $status}}]}) {
  id
  serial
  sku
  batchId
  Product{id name validity}
  }
}
`
export const GET_OPEN_BATCHES = gql`
query BatchTable($ownedBy:uuid!){
openBatches:BatchTable(where: {_and:[{isOpened: {_eq: true}}, {ownedBy: {_eq: $ownedBy}}, {status: {_eq: "InStock"}}]}){
    id
    batch
    ProductInventories(where: {_and:[{ownedBy: {_eq: $ownedBy}}, {status: {_eq: "InStock"}}]}) {
      id
      serial
      sku
      batchId
      Product{id name validity}
    }
}}
`
